import axios from "axios";
import { environment } from "../environment/environment";
import gatewayService from "@/services/gateway-service";

const trackingService = {
    async trackEvent(event) {
        const params = new URLSearchParams(window.location.search);
        const utmCampaign = params.get("utm_campaign");
        const utmSource = params.get("utm_source");
        const utmMedium = params.get("utm_medium");

        if(event.data) {
            event.data.utm_campaign = utmCampaign,
            event.data.utm_source = utmSource,
            event.data.utm_medium = utmMedium
        } else {
            event.data = {
                utm_campaign: utmCampaign,
                utm_source: utmSource,
                utm_medium: utmMedium
            };
        }

        let warmSources = ['google', 'sendinblue', 'interseguro'];

        if(warmSources.indexOf(utmSource) > -1 && event.data.leadType !== 'Caliente') {
            event.data.leadType = 'Frío'
        }

        event.data.age = event.age;

        let oldClientData = JSON.parse(window.localStorage.getItem("__maskedClientEn__") || '{}');
        let currentClientData = JSON.parse(window.localStorage.getItem("__quoteUserEditEn__") || '{}');
        let isClient = JSON.parse(window.localStorage.getItem("__isClient__") || '{}');

        const requestBody = {
            api_id: environment.apiGatewayTracking,
            body: event,
            product: "RUMBO",
            replace: gatewayService.getChangesCustomerDataEn("",currentClientData, oldClientData),
            actions: {
                "replace": isClient
            },
        };
        var result = gatewayService.postApiGateway(requestBody)

          return result;
    }
}

export default trackingService;